import Header from './Header';
import Sidebar from './Sidebar';
import css from '../sass/sitestyle.scss';

const Layout = (props) => (
  <div className={css['site-shell']}>
    <Header />
    <div className={css['page-shell']}>
      <Sidebar
        topBurgers={props.topBurgers}
        recentBurgers={props.recentBurgers}
      />
      <main className={css['page-content']}>{props.children}</main>
    </div>
    <footer className={css.footer}>Best Burger Blog · Finding the good stuff</footer>
  </div>
);

export default Layout;



// WEBPACK FOOTER //
// components/MyLayout.js